import React from 'react';
import { Typography } from '@mui/material';
const FormattedText = ({ text }) => {
    const parts = text.split(/(\*[^*]+\*)/g);
    
    return (
        <Typography
            sx={{
                fontSize: '0.85rem',
                whiteSpace: 'pre-line',
                '& strong': {
                    fontWeight: 'bold'
                }
            }}
        >
            {parts.map((part, index) => {
                if (part.startsWith('*') && part.endsWith('*')) {
                    return (
                        <Typography
                            key={index}
                            component="strong"
                            fontWeight="bold"
                            display="inline"
                        >
                            {part.slice(1, -1)}
                        </Typography>
                    );
                }
                return part;
            })}
        </Typography>
    );
};

export default FormattedText;